<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 21v-7c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 7 12h1v-2H7c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 5 8V5c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 7 3h10c.55 0 1.02.196 1.413.587C18.803 3.98 19 4.45 19 5v3c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 17 10h-1v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v7h-2v-3H7v3H5ZM7 8h10V5H7v3Zm3 4h4v-2h-4v2Zm-3 4h10v-2H7v2Z"
    />
  </svg>
</template>
